module.exports = __webpack_public_path__ + "static/media/industry-alt.9c17f7c9.svg";